<template lang="pug">
.ui.basic.segment(v-bind:class="{ loading: loading }" v-if="selected")
  .ui.stackable.two.column.grid
    .column
      .ui.rounded.fluid.image
        img(:src="imageUrl")
        .ui.bottom.attached.label(v-if="imageUrl")
          | {{ info ? (info.imageCaption ? info.imageCaption : selected) : 'No caption found.' }}
    .column(:style="[ imageUrl ? '' : 'two wide' ]")
      p(v-if="text") {{ text }}
      p(v-if="!text") No Wikipedia article found for 
        b {{selected}} &#x1F622
      hr
      .ui.rounded.fluid.image
        img(:src="resultsImage")
</template>

<script>
import wiki from 'wikijs'
var wikiApi = wiki({apiUrl: 'https://en.wikipedia.org/w/api.php'})
export default {
  name: 'wiki-summary',
  props: ['selected'],
  watch: {
    selected () {
      this.loading = true
      this.$asyncComputed.imageUrl.update()
      this.$asyncComputed.info.update()
      this.$asyncComputed.text.update()
    },
    imageUrl () {
      console.log('image watch called')
      if (Array.isArray(this.imageUrl)) {
        var filtered = this.imageUrl.filter(img => img.match(new RegExp(this.info.image + '$', 'i')))
        if (filtered) {
          this.imageUrl = filtered.pop()
        }
      } else if (!this.imageUrl) {
        this.imageUrl = 'https://via.placeholder.com/400?text=No+Image+Found'
      }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  asyncComputed: {
    resultsImage () {
      var img = 'static/results/' + this.selected + '.png'
      return img
    },
    imageUrl () {
      if (!this.selected) return Promise.resolve('')
      return wikiApi.page(this.selected).then(x => {
        return x.mainImage()
      })
      .catch(reason => {
        console.log('main image failed: ' + reason)
        return wikiApi.page(this.selected)
          .then(page => page.images())
      })
    },
    info () {
      if (!this.selected) return Promise.resolve({})
      return wikiApi.page(this.selected).then(x => x.info())
        .catch(reason => {
          console.log('page info failed' + reason)
        })
    },
    text () {
      var vm = this
      if (!this.selected) {
        vm.loading = false
        return Promise.resolve('')
      }
      return wikiApi.page(this.selected).then(x => {
        vm.loading = false
        return x.summary()
      }).catch(() => {
        vm.loading = false
        return ''
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// WikiSummary.vue?e151021c